import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Reveal } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";
import { toast } from "sonner";

export default function Contact() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      setDone(true);
      toast.success(t("contact.toast_success"));
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-32 pb-32 min-h-[70vh]">
      <div className="max-w-xl mx-auto px-6">
        <Reveal>
          <p className="overline mb-4 text-center">{t("contact.overline")}</p>
          <h1 className="font-display text-5xl md:text-6xl mb-6 text-center" style={{ fontWeight: 300 }}>{t("contact.title")}</h1>
          <p className="text-sm text-center mb-12" style={{ color: "var(--lo-muted)" }}>{t("contact.intro")}</p>
        </Reveal>
        <form onSubmit={submit} className="card-lux p-8 space-y-5" data-testid="contact-form">
          <input required placeholder={t("contact.name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="contact-name" />
          <input required type="email" placeholder={t("contact.email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="contact-email" />
          <textarea required rows={4} placeholder={t("contact.message")} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none resize-none" style={{ borderColor: "var(--lo-border)" }} data-testid="contact-message" />
          <button disabled={busy} className="btn-primary h-14 w-full disabled:opacity-50" data-testid="contact-submit">{busy ? t("contact.sending") : done ? t("contact.sent") : t("contact.send")}</button>
        </form>
      </div>
    </div>
  );
}
